/* eslint-disable */
export const IT = {
	APP: {
		LOGO_NAME: 'Portale Distribuzione',
		NAME: '- Portale Distribuzione',
		COPYRIGHT: 'Powered by',
		VERSIONE: 'Versione: '
	},
	MENU: {
		DASHBOARD: 'Home',
		ALL_NOTIFICATIONS: 'Avvisi',
		UPLOADS: 'Caricamenti in elaborazione',
		BOOKING: 'Prenotazioni',
		REQUESTS: {
			REQUESTS: 'Richieste',
			BULK_LOADING: 'Caricamento massivo',
			PUNCTUAL_LOADING: 'Caricamento puntuale',
			MONITOR: 'Monitor richieste accettate',
			MONITOR_CHRONOLOGY: 'Cronologia',
			MONITOR_FLOWS: 'Flussi richiesta',
			MONITOR_APPOINTMENTS_BOOKING: 'Prenota appuntamento',
			MONITOR_APPOINTMENTS_CHANGE: 'Modifica appuntamento',
			MONITOR_APPOINTMENTS_HISTORY: 'Storico appuntamenti',
			MONITOR_LOADING: 'Monitor Flussi Caricati',
			MONITOR_CANCEL: 'Annullamento',
			MONITOR_ATTACHMENTS: 'Allegati'
		},
		FLOWS: {
			TITLE: 'Download',
			DOWNLOAD: 'Flussi',
			COMMUNICATIONS: 'Comunicazioni',
			PDR_REGISTRY: 'Anagrafica PdR'
		},
		CREDITS: {
			TITLE: 'Accreditamenti'
		},
		SELF_READING: {
			TITLE: 'Autoletture',
			UPLOAD_SELF_READINGS: 'Caricamento Autoletture',
			TRACK_SELF_READINGS: 'Monitoraggio autoletture caricate'
		},
		TEMPLATES: {
			TITLE: 'Template',
			REQUESTS: 'Richieste',
			SELF_REPORTS: 'Autoletture'
		},
		INVOICING: {
			TITLE: 'Fatturazioni',
			INVOICES: 'Fatture e Allegati',
			WARRANTIES: 'Garanzie Finanziare'
		},
		SEARCH: {
			TITLE: 'Ricerca PdR',
			TITLE_OF_PAGE: 'Ricerca per PdR o Indirizzo',
			PDR_ADDRESS: 'Pdr Indirizzo',
			PDR_SUPPLIER: {
				TITLE: 'Forniture'
			},
			PDR_REQUEST: {
				TITLE: 'Richieste'
			},
			PDR_READING: {
				TITLE: 'Letture'
			}
			// TITLE: 'Fatturazione',
			// INVOICES: 'Fatture e allegati',
			// WARRANTIES: 'Garanzie Finanziarie'
		},
		PROFILE: {
			TITLE: 'Profilo',
			USERDATA: 'Dati Utente',
			CHANGEPSW: 'Modifica Password'
		}
	},

	LOGIN: {
		TITLE: 'Login',
		SUB_TITLE: 'Ciao! Entra con la tua email.',
		SUCCESS: 'Login eseguita',
		SUCCESS_MESSAGE: 'Hai effettuato il login con successo!',
		ERROR: 'Login fallita',
		ERRORS: {
			GENERIC: 'Si è verificato un errore, riprova più tardi',
			PASSWORD_CHANGE_REQUIRED: `E' necessario procedere con il reset della password per questa utenza.`,
			PASSWORD_CHANGE_REQUIRED_LINK_TEXT:
				'Clicca qui per procedere al reset',
			FETCH_USER:
				'Si è verificato un errore nel recupero dei dati utente',
			INVALID_CREDENTIALS: 'Username o password errati',
			WRONG_CREDENTIALS: 'La coppia Username/Password non è valida',
			ADD_OTP: 'Inserire OTP'
		},
		ERROR_MESSAGE: 'La coppia Username/Password non è valida',
		EMAIL: {
			LABEL: 'Email',
			PLACEHOLDER: 'Inserisci email',
			ERROR_REQUIRED: 'Email obbligatoria',
			ERROR_WRONG: 'Email non valida'
		},
		USERNAME: {
			LABEL: 'Username',
			PLACEHOLDER: 'Inserisci username',
			ERROR_REQUIRED: 'Username obbligatoria'
			// ERROR_WRONG: 'Email non valida'
		},
		PASSWORD: {
			LABEL: 'Password',
			PLACEHOLDER: 'Inserisci password',
			FORGOT: 'Password dimenticata?',
			RECOVER: 'Recupera password?',
			ERROR_REQUIRED: 'Password obbligatoria',
			ERROR_LENGTH:
				'La password deve contenere dai {{min}} ai {{max}} caratteri'
		},
		USER_TO_PERSONIFY: {
			LABEL: 'Utente della Distribuzione',
			PLACEHOLDER: '01219980529 - Operatore Energia S.r.l.',
			ERROR_REQUIRED: 'Utente della Distribuzione obbligatorio'
			// ERROR_WRONG: 'Email non valida'
		},
		REMEMBER_ME: 'Ricordami',
		LOGIN_BTN: 'Accedi',
		RESET_BTN: 'Reset',
		PERSONIFY_BTN: 'Conferma',
		SOCIALS_LOGIN_TITLE: 'oppure entra con',
		REGISTER: {
			NOT_ACCOUNT: 'Non sei ancora registrato?',
			REGISTER: 'Registrati'
		},
		ALERT: {
			TITLE: 'Impersonificazione Vendita',
			SUB_TITLE:
				'Per accedere al portale è necessario selezionare una vendita'
		}
	},

	MFA: {
		TITLE: 'Gestione MFA',
		DESC: "La MFA non è attiva. Premi il pulsante 'ATTIVA MFA' per generare un nuovo QrCode",
		ACTIVE_MFA: 'Attiva MFA',
		CHECK_OTP: 'Verifica OTP',
		CHECK_CODE: 'Codice di verifica',
		CHECK_CODE_ERROR: 'Codice di verifica non valido',
		CONFIRM_ACTIVATION: 'Conferma attivazione',
		SUCCESS_ACTIVATION: 'MFA configurata correttamente',
		DISABLE_MFA: 'Disattiva',
		DISABLE_MFA_DESC:
			"Sei sicuro di voler resettare la Multi-Factor Authentication per l'utente corrente",
		ERROR: 'Si è verificato un errore.'
	},

	RESET_PASSWORD: {
		SUB_TITLE: `Inserisci la username ed email dell'account di cui vuoi eseguire il reset della password.`,
		ERROR: 'Errore',
		ERROR_MESSAGE:
			'Qualcosa è andato storto durante la procedura di reset password. Riprova più tardi',
		SUCCESS: 'Reset password eseguito',
		SUCCESS_MESSAGE: `Una email contenente il link per resettare la password è stata inviata all'indirizzo associato all'utente`,
		TITLE: 'Reset password',
		EMAIL: {
			LABEL: 'Email',
			PLACEHOLDER: 'Inserisci email',
			ERROR_REQUIRED: 'Email obbligatoria'
		},
		USERNAME: {
			LABEL: 'Username',
			PLACEHOLDER: 'Inserisci username',
			ERROR_REQUIRED: 'Username obbligatoria'
		},
		NEW_PASSWORD: {
			LABEL: 'Nuova Password',
			PLACEHOLDER: 'Inserisci una nuova password',
			ERROR_REQUIRED: 'Si prega di inserire una nuova password',
			ERROR_LENGTH:
				'La password deve contenere dai {{min}} ai {{max}} caratteri'
		},
		CONFIRM_PASSWORD: {
			LABEL: 'Conferma nuova password',
			PLACEHOLDER: 'Conferma la nuova password',
			ERROR_REQUIRED: 'Si prega di confermare la nuova password',
			ERROR_NOT_MATCH:
				'La nuova password non combacia con quella confermata.'
		},
		LINK_TO_LOGIN: 'Torna alla login',
		RESET_BTN: 'Esegui il reset'
	},

	CHANGE_PASSWORD: {
		TITLE: 'Cambio password',
		SUB_TITLE: 'Ciao! Qui puoi cambiare la tua password.',
		ERROR_TITLE: 'Errore',
		ERROR_MESSAGE:
			'Qualcosa è andato storto durante la procedura di modifica password. Riprova più tardi',
		SUCCESS_TITLE: 'Cambio password eseguito con successo',
		SUCCESS_MESSAGE:
			'La password è stata correttamente modificata, puoi proseguire con la login usando la nuova password',
		USERNAME: {
			LABEL: 'Username',
			PLACEHOLDER: 'Inserisci username',
			ERROR_REQUIRED: 'Username obbligatoria'
		},
		NEW_PASSWORD: {
			LABEL: 'Nuova password',
			PLACEHOLDER: 'Inserisci una nuova password',
			ERROR_REQUIRED: 'Nuova password obbligatoria',
			ERROR_LENGTH:
				'La password deve contenere dai {{min}} ai {{max}} caratteri'
		},
		CONFIRM_PASSWORD: {
			LABEL: 'Conferma nuova password',
			PLACEHOLDER: 'Conferma la nuova password',
			ERROR_REQUIRED: 'Conferma nuova password obbligatoria',
			ERROR_NOT_MATCH: 'Le password non coincidono'
		},
		PASSOWRD_NOT_SAME: 'Le password non coincidono',
		CHANGE_BTN: 'Modifica'
	},

	// REGISTER: {
	//   TITLE: 'Registrati',
	//   ERROR: 'Registrazione fallita',
	//   SUCCESS: 'Registrazione eseguita',
	//   FULL_NAME: {
	//     LABEL: 'Nome e cognome',
	//     PLACEHOLDER: 'Inserisci nome e cognome',
	//     ERROR_REQUIRED: 'Nome e cognome obbligatori',
	//     ERROR_LENGTH:
	//       'Il nome e cognome deve contenere dai {{min}} ai {{max}} caratteri'
	//   },
	//   EMAIL: {
	//     LABEL: 'Email',
	//     PLACEHOLDER: 'Inserisci email',
	//     ERROR_REQUIRED: 'Email obbligatoria',
	//     ERROR_WRONG: 'Email non valida'
	//   },
	//   PASSWORD: {
	//     LABEL: 'Password',
	//     PLACEHOLDER: 'Inserisci password',
	//     ERROR_REQUIRED: 'Password obbligatoria',
	//     ERROR_LENGTH:
	//       'La password deve contenere dai {{min}} ai {{max}} caratteri'
	//   },
	//   CONFIRM_PASSWORD: {
	//     LABEL: 'Conferma password',
	//     PLACEHOLDER: 'Inserisci conferma password',
	//     ERROR_REQUIRED: 'Conferma password obbligatoria',
	//     ERROR_WRONG: 'Le password devono coincidere'
	//   },
	//   AGREE: 'Accetta',
	//   TERMS: 'Termini & condizioni',
	//   REGISTER_BTN: 'Registrati',
	//   SOCIALS_REGISTER_TITLE: 'oppure entra con',
	//   LOGIN: {
	//     HAVE_ACCOUNT: 'Sei già registrato?',
	//     LOGIN: 'Login'
	//   }
	// },

	DASHBOARD: {
		NOTIFICATIONS: {
			TITLE: 'Avvisi in evidenza',
			VIEW_ALL: 'Vedi tutti',
			READ: 'Leggi',
			NO_ITEMS: 'Nessun avviso presente'
		},
		FLOWS: {
			TITLE: 'Elenco flussi/files',
			ACCORDION_TITLES: {
				OUTCOMES: 'Nuovi esiti SNC',
				OUTCOMES_TOOLTIP:
					'Nuovi esiti intermedi, finali, di annullamento, di appuntamento',
				BONUS_GAS: 'Nuovi flussi Bonus Gas - (B01 - B02 - B03 - B04)',
				ACTIVE_PDR: 'Nuovi flussi per anagrafiche PdR Attivi',
				SEARCH_PDR: 'Nuovi flussi per ricerca PdR/indirizzi',
				INVOICE_OR_ATTACH:
					'Nuovi flussi per fatture in pdf e/o allegati in vettoriamento'
			},
			TABS_OUTCOMES: {
				A01: 'A01',
				A40: 'A40',
				D01: 'D01'
			},
			FIELDS_OUTCOMES: {
				COD: 'Cod.servizio/ Cod.flusso',
				COD_TOOLTIP: 'Codice Servizio / Codice Flusso',
				CHANNEL: 'Canale',
				AVAILABLE_DATE: 'Data messa a disposizione',
				AVAILABLE_DATE_TOOLTIP:
					'Data di pubblicazione del flusso sul portale',
				DOC_ID: 'Prat_utente/ Prat_distr',
				DOC_ID_TOOLTIP:
					'Codice Pratica Utente / Codice Pratica Distributore',
				PDR: 'PdR',
				OUTCOME: 'Esito',
				ID_OUTCOME: 'Matricola',
				USER_CFPIVA: 'CF/PIVA cliente',
				USER_CFPIVA_TOOLTIP: 'CF / PIVA del Cliente Finale',
				DOWNLOAD_BTN: 'Scarica'
			},
			TABS_BONUS: {
				B01: 'B01',
				B02: 'B02',
				BR1: 'BR1',
				BR2: 'BR2'
			},
			FIELDS_BONUS: {
				TYPE: 'Tipo comunicazione',
				FILENAME: 'Nome file'
			},
			TABS_REGISTRIES: {
				ANAG_PDR: 'PdR attivi',
				ANAG_PDR_SWITCH: 'Anag. Switching',
				ANAG_PDR_VTG: 'Anag. Voltura'
			},
			FIELDS_REGISTRIES: {
				OPERATOR: 'Operatore'
			},
			TAB_SEARCH_PDR: 'PdR schedulate',
			TAB_INVOICES: 'Fatture pdf',
			FIELDS_INVOICES: {
				INVOICE_NUMBER: 'Numero fattura',
				INVOICE_DATE: 'Data emissione fattura',
				MONTH_COMPETENCE: 'Mese di Competenza'
			}
		}
	},

	REQUESTS: {
		MONITOR_LOADING: {
			TITLE: 'Monitor caricamento richieste',
			REQUIRED_FIELDS: '* campi obbligatori',
			BTN_RESET: 'RESET',
			BTN_SEARCH: 'RICERCA',
			FILTER: {
				TITLE: 'Filtri di ricerca',
				LABEL: {
					REQUEST_TYPE: 'Tipo prestazione / Flusso',
					REQUEST_CHANNEL: 'Canale di acquisizione',
					REQUEST_CHANNEL_REQUIRED: 'Canale di acquisizione',
					REQUEST_FILE_NAME: 'Nome file caricato',
					REQUEST_FLOW_STATUS: 'Stato del flusso di richiesta',
					REQUEST_DATE_START: 'Data inserimento da',
					REQUEST_DATE_START_REQUIRED: 'Data inserimento da',
					REQUEST_DATE_END: 'Data inserimento a',
					REQUEST_DATE_END_REQUIRED: 'Data inserimento a',
					REQUEST_DATE: 'inserimento',
					REQUEST_CPU: 'Codice Pratica Utente',
					REQUEST_PDR: 'PdR'
				},
				PLACEHOLDER: {
					REQUEST_TYPE: 'Tipo prestazione / Flusso',
					REQUEST_CHANNEL: 'Canale di acquisizione',
					REQUEST_FILE_NAME: 'Inserisci nome file',
					REQUEST_FLOW_STATUS: 'Stato del flusso di richiesta',
					REQUEST_DATE_START: 'gg/mm/aaaa',
					REQUEST_DATE_END: 'gg/mm/aaaa',
					REQUEST_CPU: 'Codice Pratica Utente',
					REQUEST_PDR: 'PdR'
				}
			},
			LIST: {
				TOTAL_ELEMENTS: 'risultati trovati',
				EXPORT: 'Esporta risultati',
				EXPORT_TITLE:
					'Esporta in un file xlsx i dati presenti in griglia',
				FIELDS: {
					SERVICE_FLOW:
						'Cod. servizio/ Cod. Flusso | Codice Servizio / Codice Flusso',
					SERVICE_CODE: 'Cod. Servizio',
					SERVICE_DESC: 'Descrizione Servizio',
					FLOW_CODE: 'Cod. Flusso',
					CHANNEL:
						'Canale acquisizione | Canale di trasmissione del flusso (PORTALE/A2A)',
					FILE_NAME: 'Nome file caricato',
					FLOW_STATUS:
						'Stato flusso | Stato del flusso (AMMIBBILE, NON AMMISSIBILE, ATTESA AMMISSIBILITA’)',
					INPUT_DATE:
						'Data inserimento | Data di caricamento/ trasmissione del flusso',
					DOCUMENT_CODE_CONSUMER_DEALER:
						'PRAT_UTENTE/ PRAT_DISTR | Codice Pratica Utente / Codice Pratica Distributore',
					PDR_CODE: 'PdR',
					DOWNLOAD_BTN: 'Scarica'
				}
			}
		},
		PUNCTUAL_LOADING: {
			TITLE: 'Inserimento richiesta puntuale',
			FORM: {
				INPUTS: {
					TIPO_PRESTAZIONE: {
						LABEL: 'Tipo prestazione / Flusso',
						PLACEHOLDER: 'Scegli un tipo di prestazione'
					}
				}
			},
			DIALOG: {
				POSITIVE_TEXT: 'La pratica {{idPratica}} è ammissibile',
				NEGATIVE_TEXT: 'La pratica {{idPratica}} non è ammissibile',
				WAITING_TEXT:
					'La pratica {{idPratica}} è in corso di validazione'
			},
			BUTTONS: {
				MONITOR: 'Monitor richieste',
				PRENOTA: 'Prenota appuntamento',
				INSERISCI: 'Inserisci nuova richiesta'
			},
			TABLE: {
				COLUMNS: {
					COD_SERV_COD_FLUSSO: 'Codice servizio/Codice flusso',
					PIVA_UTENTE_DISTRIB: 'P.Iva utente/P.Iva distribuzione',
					PRAT_UTENTE_DISTR: 'PRAT_UTENTE/ PRAT_DISTR',
					VERIFICA_AMMISSIBILITA: 'Verifica amm.',
					COD_CAUSALE: 'Codice causale',
					MOTIVAZIONE: 'Motivazione'
				},
				ESITO_POSITIVO_VALIDAZIONE: '1',
				ESITO_NEGATIVO_VALIDAZIONE: '0',
				ACTIONS: {
					DOWNLOAD_CSV: 'Flus. Amm. CSV',
					DOWNLOAD_XML: 'Flus. Amm. XML',
					DOWNLOAD_XLSX: 'Flus. Amm. XLSX'
				}
			},
			ERRORS: {
				GENERIC: {
					TITLE: 'Errore',
					MESSAGE:
						'Si è verificato un errore lato server durante la elaborazione della richiesta'
				},
				DOWNLOAD_FILE: {
					TITLE: 'Errore',
					MESSAGE: `Non è stato possibile scaricare il file a causa di un errore lato server, riprova più tardi`
				}
			}
		},
		BULK_LOADING: {
			UPLOADER_FIRST_MESSAGE: 'Hai ',
			UPLOADER_LOADING: ' caricamenti ',
			UPLOADER_SECOND_MESSAGE: 'in fase di elaborazione'
		},
		MONITOR: {
			TITLE: 'Monitor caricamento richieste',
			REQUIRED_FIELDS: '* campi obbligatori',
			BTN_RESET: 'RESET',
			BTN_SEARCH: 'RICERCA',
			FILTER: {
				TITLE: 'Filtri di ricerca',
				LABEL: {
					REQUEST_TYPE: 'Tipo prestazione',
					REQUEST_STATUS: 'Stato della richiesta',
					REQUEST_CHANNEL: 'Canale di acquisizione',
					REQUEST_CHANNEL_REQUIRED: 'Canale di acquisizione',
					REQUEST_ID_METER: 'Matricola misuratore',
					REQUEST_PDR: 'PdR',
					REQUEST_DATE_START: 'Data inserimento da',
					REQUEST_DATE_START_REQUIRED: 'Data inserimento da',
					REQUEST_DATE_END: 'Data inserimento a',
					REQUEST_DATE_END_REQUIRED: 'Data inserimento a',
					REQUEST_DATE: 'inserimento',
					REQUEST_CPU: 'Codice Pratica Utente',
					REQUEST_CPD: 'Codice Pratica Distributore'
				},
				PLACEHOLDER: {
					REQUEST_TYPE: 'Tipo prestazione',
					REQUEST_STATUS: 'Stato della richiesta',
					REQUEST_CHANNEL: 'Canale di acquisizione',
					REQUEST_ID_METER: 'Matricola misuratore',
					REQUEST_PDR: 'PdR',
					REQUEST_DATE_START: 'gg/mm/aaaa',
					REQUEST_DATE_END: 'gg/mm/aaaa',
					REQUEST_CPU: 'Codice Pratica Utente',
					REQUEST_CPD: 'Codice Pratica Distributore'
				}
			},
			OTHER_FILTERS: {
				TITLE: 'Mostra altri filtri',
				LABEL: {
					ADMISSFLOW_DOWNLOAD_TYPE:
						'Tipo download flusso di ammissibilità',
					ADMISSFLOW_DOWNLOAD_DATE_START:
						'Data download flusso di ammissibilità da',
					ADMISSFLOW_DOWNLOAD_DATE_END:
						'Data download flusso di ammissibilità a',
					ADMISSFLOW_DOWNLOAD_DATE: 'download flusso ammissibilità',
					OUTCOMEFLOW_DOWNLOAD_TYPE: 'Tipo download flusso di esito',
					OUTCOMEFLOW_DOWNLOAD_DATE_START:
						'Data download flusso di esito da',
					OUTCOMEFLOW_DOWNLOAD_DATE_END:
						'Data download flusso di esito a',
					OUTCOMEFLOW_DOWNLOAD_DATE: 'download flusso esito',
					APPOINTMENT_TYPE: 'Tipo appuntamento',
					APPOINTMENT_DATE_START: 'Data appuntamento da',
					APPOINTMENT_DATE_END: 'Data appuntamento a',
					APPOINTMENT_DATE: 'appuntamento',
					EFFECTIVE_TYPE: 'Tipo decorrenza',
					EFFECTIVE_DATE_START: 'Data decorrenza da',
					EFFECTIVE_DATE_END: 'Data decorrenza a',
					EFFECTIVE_DATE: 'decorrenza',
					PDR_MUNICIPALITY_LOCATION: 'Comune di ubicazione PdR',
					ENDCUSTOMER_NAME: 'Nominativo cliente finale',
					ENDCUSTOMER_PIVA_CF: 'PIVA o CF cliente finale'
				},
				PLACEHOLDER: {
					ADMISSFLOW_DOWNLOAD_TYPE:
						'Tipo download flusso di ammissibilità',
					ADMISSFLOW_DOWNLOAD_DATE_START: 'gg/mm/aaaa',
					ADMISSFLOW_DOWNLOAD_DATE_END: 'gg/mm/aaaa',
					OUTCOMEFLOW_DOWNLOAD_TYPE: 'Tipo download flusso di esito',
					OUTCOMEFLOW_DOWNLOAD_DATE_START: 'gg/mm/aaaa',
					OUTCOMEFLOW_DOWNLOAD_DATE_END: 'gg/mm/aaaa',
					APPOINTMENT_TYPE: 'Tipo appuntamento',
					APPOINTMENT_DATE_START: 'gg/mm/aaaa',
					APPOINTMENT_DATE_END: 'gg/mm/aaaa',
					EFFECTIVE_TYPE: 'Tipo decorrenza',
					EFFECTIVE_DATE_START: 'gg/mm/aaaa',
					EFFECTIVE_DATE_END: 'gg/mm/aaaa',
					PDR_MUNICIPALITY_LOCATION: 'Comune di ubicazione PdR',
					ENDCUSTOMER_NAME: 'Nominativo cliente finale',
					ENDCUSTOMER_PIVA_CF: 'PIVA o CF cliente finale'
				}
			},
			LIST: {
				TOTAL_ELEMENTS: 'risultati trovati',
				EXPORT: 'Esporta risultati',
				EXPORT_TITLE:
					'Esporta in un file xlsx i dati presenti in griglia',
				FIELDS: {
					SERVICE_CODE_FLOW: 'Cod. Servizio | Codice Servizio',
					SERVICE_DESC: 'Descrizione Servizio',
					CHANNEL:
						'Canale acquisizione | Canale di caricamento/trasmissione del primo flusso (PORTALE/A2A)',
					REQUEST_STATUS:
						'Stato richiesta | Stato avanzamento della richiesta',
					INPUT_DATE:
						'Data inserimento | Data di caricamento/trasmissione del primo flusso',
					DOCUMENT_CODE_CONSUMER_DEALER:
						'PRAT_UTENTE/ PRAT_DISTR | Codice Pratica Utente / Codice Pratica Distributore',
					PDR_CODE: 'PdR',
					APPOINTMENT_DATE:
						'Data Appuntamento | Data dell’appuntamento stipulato per la richiesta',
					END_CONSUMER_NAME_SURNAME: 'Cliente finale',
					END_CONSUMER_PIVA_CF:
						'CF/PIVA cliente | CF / PIVA del Cliente Finale',
					ID_METER: 'Matricola Misuratore | Matricola del Misuratore',
					PDR_MUNICIPALITY_LOCATION:
						'Comune PDR | Comune di ubicazione del PDR',
					ADMISS_FLOW_DOWNLOAD_DATE:
						'Data Download ammissibilità | Data di download del flusso di ammissibilità',
					OUTCOME_FLOW_DOWNLOAD_DATE:
						'Data Download esito finale | Data di download del flusso di esito finale',
					EFFECTIVE_DATE: 'Data decorrenza | Data di decorrenza',
					DOWNLOAD_BTN: 'Scarica'
				},
				DROPDOWN_ACTIONS: {
					HISTORY: 'Cronologia',
					FLOWS: 'Flussi',
					BOOKING_APPOINTMENT: 'Prenota appuntamento',
					MODIFY_APPOINTMENT: 'Modifica appuntamento',
					HISTORY_APPOINTMENTS: 'Storico appuntamenti',
					CANCEL: 'Annullamento',
					ATTACHMENTS: 'Allegati'
				}
			},
			CHRONOLOGY: {
				LIST: {
					EXPORT: 'Esporta risultati',
					FIELDS: {
						DATA_CHANGE_STATUS: 'Data/ora evoluzione di stato',
						DATA_RICHIESTA: 'Data richiesta',
						COD_PRAT_UTENTE: 'Cod. Prat. Utente',
						COD_PRAT_DISTR: 'Cod. Prat. Distributore',
						STATO_RICHIESTA: 'Stato richiesta',
						PDR: 'PdR'
					}
				}
			},
			FLOWS: {
				LIST: {
					TOTAL_ELEMENTS: 'risultati trovati',
					EXPORT: 'Esporta risultati',
					EXPORT_TITLE:
						'Esporta in un file xlsx i dati presenti in griglia',
					FIELDS: {
						DOCUMENT_CODE_CONSUMER:
							'PRAT_UTENTE | Codice Pratica Utente',
						DOCUMENT_CODE_DEALER:
							'PRAT_DISTR | Codice Pratica Distributore',
						PDR_CODE: 'PdR',
						SERVICE_FLOW_CODE:
							'Cod. servizio / Cod. Flusso | Codice Servizio / Codice Flusso',
						SERVICE_CODE: 'Cod. Servizio',
						FLOW_CODE: 'Cod. Flusso',
						INPUT_DATE:
							'Data inserimento | Data di trasmissione del flusso',
						DOWNLOAD_DATE:
							'Data download | Data di download del flusso',
						DOWNLOAD_BTN: 'Scarica'
					}
				}
			},
			APPOINTMENTS_BOOKING: {
				FILTER: {
					TITLE: 'Verifica disponibilità',
					LABEL: {
						DATE_DAY: 'Giorno',
						DATE_HOUR: 'Ora',
						DURATION: 'Stima durata',
						ALLOW_ADVANCE: 'Consenti anticipo'
					},
					PLACEHOLDER: {
						DATE_DAY: 'dd/mm/aaaa',
						DATE_HOUR: 'hh:mm',
						DURATION: 'mm',
						ALLOW_ADVANCE: 'Consenti anticipo'
					},
					SEARCH: 'RICERCA'
				},
				LIST: {
					TOTAL_ELEMENTS: 'elementi trovati',
					FIELDS: {
						DATE_EEEE: 'Giorno',
						DATE_DDMMYYYY: 'Data',
						DATE_HH_FROM: 'Ora (da)',
						DATE_HH_TO: 'Ora (a)',
						TYPE: 'Tipo',
						DATE_DEADLINE_MODIFICATION: 'Data limite modifica'
					}
				},
				SUCCESS_DIALOG_TEXT: 'La prenotazione è andata a buon fine',
				FAIL_DIALOG_TEXT:
					"Non è stato possibile prenotare un appuntamento per la data e l'ora selezionate",
				WAITING_DIALOG_TEXT:
					'La prenotazione è in attesa di essere confermata'
			},
			APPOINTMENTS_CHANGE: {
				FILTER: {
					TITLE_LAST_APPOINTMENT: 'Appuntamento negoziato:',
					TITLE: 'Verifica disponibilità',
					LABEL: {
						DATE_DAY: 'Giorno',
						DATE_HOUR: 'Ora',
						DURATION: 'Stima durata',
						ALLOW_ADVANCE: 'Consenti anticipo',
						DATE_DAY2: 'Giorno',
						DATE_HOUR2: 'Ora'
					},
					PLACEHOLDER: {
						DATE_DAY: 'dd/mm/aaaa',
						ALLOW_ADVANCE: 'Consenti anticipo',
						DATE_HOUR: 'hh:mm',
						DURATION: 'mm',
						DATE_DAY2: 'dd/mm/aaaa',
						DATE_HOUR2: 'hh:mm'
					},
					SEARCH: 'RICERCA'
				},
				LIST: {
					TOTAL_ELEMENTS: 'elementi trovati',
					FIELDS: {
						DATE_EEEE: 'Giorno',
						DATE_DDMMYYYY: 'Data',
						DATE_HH_FROM: 'Ora (da)',
						DATE_HH_TO: 'Ora (a)',
						TYPE: 'Tipo',
						DATE_DEADLINE_MODIFICATION: 'Data limite modifica'
					}
				},
				SUCCESS_DIALOG_TEXT: 'La prenotazione è andata a buon fine',
				FAIL_DIALOG_TEXT:
					"Non è stato possibile prenotare un appuntamento per la data e l'ora selezionate",
				WAITING_DIALOG_TEXT:
					'La prenotazione è in attesa di essere confermata'
			},
			APPOINTMENTS_HISTORY: {
				LIST: {
					TOTAL_ELEMENTS: 'appuntamenti',
					FIELDS: {
						DOCUMENT_CODE_CONSUMER:
							'Prat. Utente | Codice Pratica utente della richiesta',
						PDR_CODE: 'PdR',
						APPOINTMENT_CODE:
							'Codice appuntamento | Codice assegnato dal distributore all’appuntamento',
						APPOINTMENT_STATE:
							'Stato appuntamento | Stato dell’appuntamento',
						APPOINTMENT_OUTCOME:
							'Esito appuntamento | Esito dell’appuntamento',
						APPOINTMENT_OUTCOME_0:
							'Mancato intervento causa cliente, 2° appuntamento vendita',
						APPOINTMENT_OUTCOME_1:
							'Mancato intervento causa cliente, 2° appuntamento distributore',
						APPOINTMENT_OUTCOME_2:
							'Mancato intervento causa distributore',
						APPOINTMENT_OUTCOME_3:
							'Mancato intervento causa forza maggiore',
						APPOINTMENT_OUTCOME_4: 'Esito positivo',
						APPOINTMENT_OUTCOME_DESC:
							'Descrizione | Descrizione dell’esito appuntamento',
						APPOINTMENT_ORIGIN:
							'Provenienza appuntamento | Indica se l’appuntamento è stato stipulato in vendita o in distribuzione',
						APPOINTMENT_DATE:
							'Data e fascia appuntamento | Data e fascia oraria dell’appuntamento'
					}
				}
			},
			CANCEL: {
				FIRST_TEXT:
					'Attenzione! Stai per annullare la richiesta con codice pratica ',
				SECOND_TEXT: 'Vuoi continuare?',
				DIALOG: {
					POSITIVE_TEXT: 'Annullamento pratica avvenuto con successo',
					NEGATIVE_TEXT:
						"Si è verificato un errore durante l'annullamento di questa pratica",
					WAITING_TEXT:
						"L'annullamento della pratica è in attesa di essere completato"
				},
				LIST: {
					FIELDS: {
						SERVICE_CODE_FLOW: 'Codice servizio/ Codice flusso',
						PIVA_CONSUMER_DEALER:
							'P.Iva utente / P.Iva distribuzione',
						DOCUMENT_CODE_CONSUMER_DEALER:
							'PRAT. UTENTE/ PRAT_DISTR',
						CHECK_ADMISSIBILITY: 'Verifica amm.',
						CODE_CAUSE: 'Codice causale',
						CAUSE: 'Motivazione'
					}
				}
			},
			ATTACHMENTS: {
				LIST: {
					TOTAL_ELEMENTS: 'risultati trovati',
					FIELDS: {
						FILE_NAME: 'Nome file | Nome del file allegato',
						DOC_TYPE:
							'Tipo documento | Tipologia di documento allegato',
						UPLOAD_DATE:
							'Data caricamento | Data di caricamento del file allegato',
						AVAILABLE_DATE:
							'Data messa a disposizione | Data di pubblicazione dell’allegato sul portale'
					}
				}
			}
		},
		DETAILS: {
			LABEL: {
				CODES: 'Codice servizio/ Codice flusso',
				PIVAS: 'P.Iva utente / P.Iva distribuzione',
				PRATS: 'PRAT_UTENTE/ PRAT_DISTR',
				ESITO: 'Verifica amm.',
				CAUSALE: 'Codice causale',
				CAUSE: 'Motivazione'
			}
		}
	},

	INVOICES: {
		LIST: {
			FILTERS: {
				DATE_SENT_START: {
					LABEL: 'Data emissione fattura da',
					LABEL_OBLIGATORY: 'Data emissione fattura da*',
					PLACEHOLDER: 'Seleziona intervallo date'
				},
				DATE_SENT_END: {
					LABEL: 'Data emissione fattura a',
					LABEL_OBLIGATORY: 'Data emissione fattura a*',
					PLACEHOLDER: 'Seleziona intervallo date'
				},
				NEW_DOCUMENTS: {
					LABEL: 'Nuovi documenti'
				},
				DATE_AVAILABLE_START: {
					LABEL: 'Data messa a disposizione da',
					LABEL_OBLIGATORY: 'Data messa a disposizione da*',
					PLACEHOLDER: 'Seleziona intervallo date'
				},
				DATE_AVAILABLE_END: {
					LABEL: 'Data messa a disposizione a',
					LABEL_OBLIGATORY: 'Data messa a disposizione a*',
					PLACEHOLDER: 'Seleziona intervallo date'
				},
				DATE_DOWNLOAD_START: {
					LABEL: 'Data download da',
					LABEL_OBLIGATORY: 'Data download da*',
					PLACEHOLDER: 'Seleziona intervallo date'
				},
				DATE_DOWNLOAD_END: {
					LABEL: 'Data download a',
					LABEL_OBLIGATORY: 'Data download a*',
					PLACEHOLDER: 'Seleziona intervallo date'
				}
			}
		}
	},

	DOWNLOAD: {
		LABEL_OPTIONAL: {
			SELECTION_FLOW: 'Tipo prestazione/flusso',
			SELECTION_FLOW_PLACEHOLDER: 'Seleziona una prestazione/flusso',
			DATE_AVAILABLE_FROM: 'Data messa a disposizione da',
			DATE_AVAILABLE_TO: 'Data messa a disposizione a',
			DATE_AVAILABLE: 'messa a disposizione',
			DATE_EFFECTIVE_FROM: 'Data decorrenza da',
			DATE_EFFECTIVE_TO: 'Data decorrenza a',
			DATE_EFFECTIVE: 'decorrenza',
			USER_CODE: 'Codice pratica utente',
			DISTRIBUTOR_CODE: 'Codice pratica distributore',
			PDR: 'PDR'
		},
		LABEL_OBLIGATORY: {
			SELECTION_ESIT: 'Tipo di esito',
			SELECTION_ESIT_PLACEHOLDER: 'Seleziona un tipo di esito',
			SELECTION_CHANNEL: 'Canale di acquisizione',
			SELECTION_CHANNEL_PLACEHOLDER:
				'Seleziona un canale di acquisizione',
			DATE_DOWNLOAD_FROM: 'Data download da',
			DATE_DOWNLOAD_TO: 'Data download a',
			DATE_DOWNLOAD: 'download'
		},
		TOOLTIP: 'Questo campo non è disponibile quando si cercano nuovi esiti',
		CHECKBOXES: {
			OUTCOME: 'Nuovi esiti'
		},
		DATE_PLACEHOLDER: 'Seleziona data',
		EMPTY_PLACEHOLDER: '',
		LIST: {
			FIELDS: {
				CODES: 'Cod. Servizio / Cod. flusso | Codice Servizio / Codice Flusso',
				FLOW_NAME:
					'Descrizione esito | Descrizione dell’esito del flusso',
				CHANNEL:
					'Canale Acquisizione | | Canale di trasmissione del flusso (PORTALE/A2A)',
				CODES_PRAT:
					'Prat_utente/Prat_distr | Codice Pratica Utente / Codice Pratica Distributore',
				PDR: 'PDR',
				OUTCOME_CODE: 'Codice esito | Codice Esito del flusso',
				DISPOSITION_DATE:
					'Data disposizione flusso di esito | Data di messa a disposizione del flusso',
				DOWNLOAD_DATE: 'Data download | Data di download del flusso'
			}
		},
		FILE_ERROR:
			'Non è possibile effettuare l’export in quanto sono presenti tipi di prestazione/flusso differenti'
	},

	COMMUNICATIONS: {
		LABEL_OPTIONAL: {
			COMMUNICATION: 'Tipo comunicazione',
			OPERATOR: 'Operatore',
			DATE_COMMUNICATION_FROM: 'Data messa a disposizione da',
			DATE_COMMUNICATION_TO: 'Data messa a disposizione a',
			DATE_COMMUNICATION: 'messa a disposizione'
		},
		LABEL_OBBLIGATORY: {
			DATE_DOWNLOAD_FROM: 'Data download da',
			DATE_DOWNLOAD_TO: 'Data download a',
			DATE_DOWNLOAD: 'download'
		},
		CHECKBOXES: {
			COMMUNICATION: 'Nuove comunicazioni'
		},
		PLACEHOLDER: {
			COMMUNICATION: 'Seleziona una comunicazione',
			EMPTY: '',
			OPERATOR: 'Operatore',
			DATE: 'Seleziona data'
		},
		LIST: {
			TOTAL_ELEMENTS: 'risultati trovati',
			FIELDS: {
				COMMUNICATION_TYPE: 'Tipo Comunicazione',
				FILE_NAME: 'Nome file | Nome del file',
				OPERATOR:
					'Operatore | Operatore che ha generato la comunicazione',
				ID: 'ID',
				DISPOSITION_DATE:
					'Data Disposizione Comunicazione | Data di messa a disposizione della comunicazione',
				DOWNLOAD_DATE:
					'Data Download | Data di download della comunicazione'
			}
		}
	},

	PDR_REGISTRY: {
		LABEL_OPTIONAL: {
			REGISTRY_TYPE: 'Tipo Anagrafica',
			DATE_EFFECTIVE_FROM: 'Data decorrenza da',
			DATE_EFFECTIVE_TO: 'Data decorrenza a',
			DATE_EFFECTIVE: 'decorrenza'
		},
		PLACEHOLDER: {
			REGISTRY: 'Segli anagrafica',
			DATE: 'Inserisci data'
		},
		DIALOG: {
			POSITIVE_TITLE_SWITCHING: 'Estrazione Switching avviata',
			POSITIVE_TITLE_PDR_ACTIVE:
				'Estrazione Anagrafica PDR attivi avviata',
			POSITIVE_TITLE_VOLTURA: 'Estrazione Voltura avviata',
			POSITIVE_TEXT:
				'Al termine dell’elaborazione è possibile effettuare il download del file nella sezione Comunicazioni',
			POSITIVE_TEXT_TEMPLATE: `Al termine sarà possibile scaricare l'esito sotto la voce: `,
			POSITIVE_TEXT_TEMPLATE_LINK: 'Download/Comunicazioni',
			NEGATIVE_TITLE_SWITCHING: 'Estrazione Switching non avviata',
			NEGATIVE_TITLE_PDR_ACTIVE:
				'Estrazione Anagrafica PDR attivi non avviata',
			NEGATIVE_TITLE_VOLTURA: 'Estrazione Voltura non avviata',
			NEGATIVE_TEXT:
				"Si è verificato un errore durante l'estrazione di questa anagrafica",
			WAITING_TEXT: "L'anagrafica è in attesa di essere estratta"
		}
	},

	SEARCH_PDR: {
		SCHEDULE_RESEARCH: {
			ERROR: {
				TITLE: 'Errore',
				MESSAGE:
					'Non è stato possibile avviare la ricerca schedulata dei pdr, riprova più tardi'
			},
			SUCCESS: {
				TITLE: 'La ricerca schedulata è stata avviata.',
				MESSAGE: `Al termine sarà possibile scaricare l'esito sotto la voce: `,
				LINK: 'Download/Comunicazioni'
			}
		}
	},

	PDR_SUPPLIER: {
		FIELDS: {
			PDR_TYPE: 'Tipo PdR',
			MARKET_TYPE:
				'Tipo mercato | Indica se il PDR è attivo con UDD, FUI o FDD',
			SUPPLY_ACTIVATION_DATE:
				'Data attivazione | Data di attivazione della fornitura',
			SUPPLY_DISCONNECT_DATE:
				'Data disattivazione | Data di disattivazione della fornitura',
			FINAL_CLIENT_NAME:
				'Nome e cognome Cliente | Nome e cognome del Cliente Finale ',
			FINAL_CLIENT_SURNAME: 'Cognome del cliente finale',
			FINAL_CLIENT_BUSINESS_NAME:
				'Ragione Sociale cliente | Ragione Sociale del Cliente Finale',
			FINAL_CLIENT_FISCAL_CODE:
				'CF Cliente | Codice Fiscale del Cliente Finale',
			FINAL_CLIENT_VAT_NUMBER:
				'PIVA cliente finale | Partita Iva del Cliente Finale',
			FINAL_CLIENT_FROM_TO:
				'Intestatario dal - al | Indica il periodo nel quale la fornitura è intestata al Cliente Finale',
			FINAL_CLIENT_FROM: 'Intestatario cliente finale dal',
			FINAL_CLIENT_TO: 'Intestatario cliente finale al',
			ANNUAL_VOLUME: 'CAPDR | Volume annuo',
			WITHDRAWAL_PROFILE: 'Profilo di prelievo',
			COEFFICIENT_C: 'Coefficiente C'
		}
	},
	PDR_REQUEST: {
		FIELDS: {
			SERVICE_CODE: 'Codice Servizio',
			FLOW_CODE: 'Codice Flusso',
			PRACTICE_CODES:
				'Prat_utente/Prat_distr | Codice Pratica Utente / Codice Pratica Distributore',
			USER_CODE: 'PRAT_UTENTE',
			DISTRIBUTOR_CODE: 'PRAT_DISTR',
			ACQUISITION_CHANNEL:
				'Canale acquisizione | Canale di caricamento/trasmissione del primo flusso (PORTALE/A2A)',
			REQUEST_INSERTED_DATE:
				'Data inserimento | Data di caricamento/trasmissione del primo flusso',
			REQUEST_CHECK_DATE:
				'Data/ora ultima evoluzione di stato | Data/ora dell’ultima evoluzione di stato della richiesta',
			REQUEST_STATE:
				'Stato attuale della richiesta | Stato avanzamento della richiesta'
		}
	},
	PDR_READING: {
		PDR_READING_STATE: {
			MAN: 'MANCATA',
			VAL: 'VALIDATA'
		},
		TYPE_CONS_MIS: {
			Z: 'CONSUMO ZERO',
			G: 'CONSUMO DA GIRO CONTATORE',
			N: 'NORMALE',
			F: 'CONSUMO FORZATO'
		},
		FIELDS: {
			READING_PDR_CODE: 'PdR',
			READING_MISSING: 'Mancate letture',
			READING_FINAL_CLIENT_NAME: 'Nominativo Cliente Finale',
			READING_FINAL_CLIENT_CF: 'Codice Fiscale Cliente Finale',
			READING_FINAL_CLIENT_IVA_CODE: 'Partita IVA Cliente Finale',
			READING_DATE: 'Data lettura',
			READING_STATE: 'Stato lettura',
			READING_SOURCE: 'Provenienza lettura',
			READING_TYPE: 'Tipo lettura',
			METER_SERIAL_NUMBER: 'Matricola Mis. | Matricola Misuratore',
			METER_MARKER: 'Segnante Mis. | Segnante Misuratore',
			COEFFICIENT_C: 'Coefficiente C',
			CONVERTER_SERIAL_NUMBER: 'Matricola conv. | Matricola Convertitore',
			METER_CONVERTER: 'Segnante conv. | Segnante Convertitore',
			CONSUMPTION_MARKER: 'Cons mis. | Consumo Misuratore',
			CONSUMPTION_MARKER_SMC: 'Cons mis. smc | Consumo Misuratore Smc',
			CONSUMPTION_CONVERTER: 'Cons conv. | Consumo Convertitore',
			CORRECTION_TYPE: 'Sistema di Lettura | Tipo strumento',
			AEEG_CAUSE: 'Causale AEEG',
			ENFORCEMENT_REASON: 'Motivazione forzatura',
			CONSUMPTION_MARKER_TYPE:
				'Tipo cons. mis. | Tipo consumo misuratore',
			CONVERTER_MARKER_TYPE: 'Tipo consumo convertitore',
			MISSING_READING_REASON: 'Causale mancata lettura',
			READING_FREQUENCY: 'Frequenza lettura',
			READING_NEXT: 'Prossima lettura'
		}
	},

	BOOKING: {
		CALENDAR: {
			TAB_TITLE: 'Calendario',
			TODAY: 'Oggi',
			MONTH: 'Mese',
			WEEK: 'Settimana',
			DAY: 'Giorno'
		},

		LIST: {
			TAB_TITLE: 'Lista',
			TITLE: 'Lista prenotazioni',
			TOTAL_ELEMENTS: ' prenotazioni',
			EXPORT: 'Esporta',
			FIELDS: {
				START_DATE: 'Dal',
				END_DATE: 'Al',
				BOOKING_DATE: 'Data prenotazione',
				ID: 'Id',
				TYPE: 'Tipo',
				ADDRESS: 'Indirizzo',
				CITY: 'Città',
				PRICE: 'Prezzo',
				USER_FULLNAME: 'Utente',
				COMPANY: 'Azienda',
				AMOUNT: 'Totale',
				DISCOUNT: 'Sconto',
				DISCOUNT_CODE: 'Codice sconto',
				NOTES: 'Note'
			},
			FILTERS: {
				DATE_INTERVALL: {
					LABEL: 'Periodo',
					PLACEHOLDER: 'Seleziona intervallo date'
				},
				USER: {
					LABEL: 'Utente',
					PLACEHOLDER: `Inserisci utente`
				},
				COMPANY: {
					LABEL: 'Azienda',
					PLACEHOLDER: `Inserisci azienda`
				},
				TYPE: {
					LABEL: 'Tipo',
					PLACEHOLDER: `Inserisci tipo`
				},
				CITY: {
					LABEL: 'Città',
					PLACEHOLDER: `Inserisci città`
				},
				PRICE: {
					LABEL: 'Prezzo',
					PLACEHOLDER: `Inserisci prezzo`
				}
			},
			MODAL_DETAIL_TITLE: 'Dettaglio prenotazione'
		}
	},
	PDR_ADDRESS: {
		BUTTON_EXPORT: 'Esporta risultati',
		BUTTON_DOWNLOAD: {
			PDR_REGISTRY: 'Anagrafica PdR',
			XLS_LOAD_SUCCESS: 'Il file excel è stato caricato'
		},
		PDR_STATUS: {
			TITLE: 'Stato PdR',
			PLACEHOLDER: 'Seleziona stato'
		},
		RADIO_LABEL: 'Tipo ricerca',
		PDR_RADIO: 'PdR',
		ADDRESS_RADIO: 'Indirizzo',
		SERIAL_NUMBER: 'Matricola',
		VIRTUAL_REM: 'Remi virtuale',
		ADDRESS: 'Indirizzo',
		TOPONYM: 'Toponimo',
		STREET_NUMBER_FROM: 'Civico Da',
		STREET_NUMBER_TO: 'Civico A',
		SUFFIX: 'Suffisso',
		STAIRCASE: 'Scala',
		FLOOR: 'Piano',
		INTERIOR: 'Interno',
		LOCAL: 'Località',
		CAP: 'Cap',
		COMMON: 'Comune',
		SEARCH_COMMON: 'Cerca un comune',
		PROVINCE: 'Provincia',
		LIST: {
			PDR: 'PdR',
			PDR_STATE: 'Stato PdR',
			ADDRESS: 'Indirizzo',
			VECTOR_DATE_INITIAL: 'Data inizio',
			VECTOR_DATE_FINAL: 'Fine',
			VECTOR: ' vettoriamento',
			MATRIX_MEASURE: 'Matricola misuratore',
			MATRIX_CONVERTER: 'Matricola convertitore',
			MEASURE_CLASS: 'Classe misurazione',
			PRESSURE: 'Pressione',
			FINAL_COSTUMER: 'Cliente finale',
			FISCAL_CODE: ' Codice fiscale cliente finale',
			VAT: 'P.iva cliente finale',
			MARKET_TYPE: ' Tipo mercato',
			USE_CATEGORY: "Categoria d'uso",
			LECTURE_FREQUENCY: 'Frequenza di lettura',
			CA_PDR: 'CA_PDR',
			ACCORDION: {
				PRESSURE: 'Pressione',
				MARKET_TYPE: 'Tipo mercato',
				FINAL_COSTUMER: 'Cliente finale',
				USE_CATEGORY: "Categoria d'uso",
				FISCAL_CODE: 'C.F cliente finale',
				READING_FREQUENCY: 'frequenza lettura',
				VAT_NUMBER: 'P.iva cliente finale ',
				CA_PDR: 'CA PdR'
			}
		}
	},

	SELF_READING: {
		UPLOAD: {
			UPLOADER_FIRST_MESSAGE: 'Hai ',
			UPLOADER_LOADING: ' caricamenti ',
			UPLOADER_SECOND_MESSAGE: 'in fase di elaborazione'
		},
		FIELDS: {
			FLOW_TYPE: 'Tipo Flusso',
			FLOW_SERVICE_TYPE: 'Tipo Prestazione / Flusso',
			FILE_NAME: 'Nome file',
			BROWSE_TYPES: 'Scegli file in formato csv, xml o xlsx',
			BROWSE_BUTTON: 'sfoglia',
			BROWSE_DELETE: 'rimuovi',
			LOADING_PROGRESS: 'Caricamento in corso',
			LOADING_COMPLETED: 'Caricamento completato',
			FLOW_STATE: 'Stato flusso',
			INSERT_DATE_START: 'Data inserimento da',
			INSERT_DATE_END: 'Data inserimento a',
			RESULT_DATE: 'Data caricamento',
			FLOW_RESULT: 'Esito Caricamento',
			FILE_LINK: 'File originale'
		}
	},

	CREDITS: {
		FIELDS: {
			VIRTUAL_REMI: 'Remi Virtuale',
			VIRTUAL_REMI_SELECT: 'Remi Virtuale',
			VIRTUAL_REMI_SELECT_PLACEHOLDER: 'Seleziona un Remi Virtuale',
			VIRTUAL_REMI_DESCRIPTION: 'Descrizione Remi',
			CREDIT_START_DATE: 'Da',
			CREDIT_END_DATE: 'A',
			USER_COMPANY: 'Utente del Bilanciamento',
			PERCENTAGE_VOLUME_UdB: 'Percentuale per Volume per UdB'
		}
	},

	INVOICING: {
		FIELDS: {
			INVOICE: {
				NUMBER: 'Numero Fattura',
				DATE: 'Data emissione fattura',
				RELEVANT_MONTH: 'Mese di competenza',
				FILE: 'Fattura',
				HASH_NUMBER: 'Allegato vettoriamento e file hash',
				DATE_PUBBLICATION: 'Data pubblicazione allegato'
			},
			WARRANTIES: {
				ACTIVE_PDR: '#PdR Attivi',
				DATE_ORDERED: 'Data richiesta',
				ANNUAL_TURNOVER_VALUE: 'Valore annuo fatturato',
				CALCULATED_WARRANTY_VALUE: 'Valore garanzia calcolato',
				EXPIRATION_DATE: 'Data scadenza',
				STATE: 'Stato',
				ATTACHED_WARRANTY: 'Allegati garanzia'
			},
			DOCUMENTS: {
				FILE_NAME: 'Nome file',
				DOCUMENT_TYPE: 'Tipo documento',
				DATE_AVAIBLE: 'Data messa disposizione',
				DATE_DOWNLOAD: 'Data download'
			}
		},
		BUTTONS: {
			DOWNLOAD: 'Scarica',
			DOWNLOAD_SELECTED: 'Scarica file selezionati'
		}
	},

	TEMPLATES: {
		FIELDS: {
			SERVICE_CODE: 'Codice Servizio',
			FILE_NAME: 'Nome File',
			FILE_LINK: 'Links'
		},
		BUTTONS: {
			DOWNLOAD: 'Scarica'
		}
	},

	PROFILE: {
		USERDATA: {
			FIELDS: {
				USERNAME: {
					LABEL: 'Username',
					PLACEHOLDER: 'Username'
				},
				NAME: {
					LABEL: 'Nome',
					PLACEHOLDER: 'Nome'
				},
				SURNAME: {
					LABEL: 'Cognome',
					PLACEHOLDER: 'Cognome'
				},
				EMAIL: {
					LABEL: 'E-mail',
					PLACEHOLDER: 'E-mail'
				},
				TELEPHONE: {
					LABEL: 'Telefono',
					PLACEHOLDER: 'Telefono'
				},
				BUSINESS_NAME: {
					LABEL: 'Ragione Sociale UdD',
					PLACEHOLDER: 'Ragione Sociale UdD'
				},
				OPERATOR_TYPE: {
					LABEL: 'Tipo Operatore',
					PLACEHOLDER: 'Tipo Operatore'
				},
				PARTITA_IVA: {
					LABEL: 'Partita Iva UdD',
					PLACEHOLDER: 'Partita Iva UdD'
				}
			}
		},
		CHANGEPSW: {
			FIELDS: {
				PSW: {
					LABEL: 'Password',
					PLACEHOLDER: `Password attuale`
				},
				CHANGE_PSW: {
					LABEL: 'Nuova Password',
					PLACEHOLDER: `Nuova Password`
				},
				CONFIRM_PSW: {
					LABEL: 'Conferma Nuova Password',
					PLACEHOLDER: `Conferma Nuova Password`
				}
			},
			CONFIRM_PSW_SUCCESS: 'La password è stata modificata con successo',
			CONFIRM_PSW_FAILED:
				'La password non è stata modificata, si prega di riprovare in un secondo momento'
		}
	},

	UPLOADS: {
		TITLE: 'Caricamenti in Elaborazione',
		FIELDS: {
			SECTION: 'Sezione di caricamento',
			CODES: 'Cod. Servizio / Cod. Flusso',
			FILE_NAME: 'Nome file',
			UPLOAD_DATE: 'Data inserimento',
			STATE: 'Stato',
			TOTAL_REQS: '# rich. Totali',
			AMM_REQS: '# rich. Amm.',
			NOT_AMM_REQS: '# rich. Non amm.',
			WAITING_REQS: '# rich. in attesa',
			NOT_ELAB_REQS: '# rich. non elab.'
		},
		DROPDOWN: {
			REQUESTS: 'Monitor caricamento richieste',
			SELF_READING: 'Monitor autoletture'
		},
		NO_FILE_LOG_TOASTR: {
			TITLE: 'Download file log'
		}
	},

	NOT_FOUND: {
		TITLE: '404 Pagina non trovata',
		SUB_TITLE: 'La pagina non sembra esistere',
		GO_TO_HOME: 'Portami alla Home'
	},

	NOT_AUTHORIZED: {
		MODAL: {
			TITLE: 'Sessione scaduta',
			LONG_TEXT: `Attenzione: per motivi di sicurezza è necessario eseguire nuovamente l'accesso`,
			BUTTONS: {
				GO_TO_LOGIN: 'Vai alla login'
			}
		},
		TITLE: '401 Accesso non consentito',
		SUB_TITLE: 'Non si hanno i permessi per accedere alla pagina',
		GO_TO_LOGIN: 'Portami alla Login'
	},

	UTILS: {
		DIALOG: {
			SWITCHING: 'Estrazione switching avviata',
			SWITCHING_MESSAGE:
				"Al termine dell'elaborazione è possibile effettuare il download del file nella sezione Comunicazione"
		},
		TOASTR: {
			GENERIC_ERROR: {
				TITLE: 'Errore',
				MESSAGE: `C'è stato un errore, riprova più tardi`
			},
			ERROR_UPLOAD_DOCUMENT: {
				TITLE: 'Documento non caricato',
				MESSAGE: 'Non è stato possibile caricare il documento'
			},
			TIME: {
				TITLE: 'Errore Data esame',
				MESSAGE: 'Deve essere posteriore alla data odierna'
			},
			UPLOAD: {
				TITLE: 'Attenzione!',
				MESSAGE:
					'Il documento che si vuole caricare è già presente in archivio'
			},
			UPLOAD_SUCCESS: {
				TITLE: 'Caricamento completato',
				MESSAGE: 'Il file verrà elaborato dal sistema'
			}
		},
		TABLE: {
			TOTAL_ROWS: 'risultati trovati',
			EMPTY: 'Nessuna corrispondenza trovata',
			INFO_PAGE: '{{page}} di {{total}} pagine',
			SIZE_PAGE_SELECT: 'righe per pagina'
		},
		AUTOCOMPLETE: {
			TYPE_TO_SEARCH: 'Scrivi per cercare...',
			ITEMS_NOT_FOUND: 'Elemento non trovato',
			INSERT_MIN_CHARACTERS: 'Inserisci almeno un carattere'
		},
		SELECT: {
			CLEAR_CHOICE: 'Tutti'
		},
		FORM: {
			LABEL_NOT_MANDATORY: '(facoltativo)'
		},
		DOWNLOAD_ACTIONS: {
			ORIGINAL_FILE: 'File originale',
			LOG_FILE: 'File Log Elab.',
			CSV_AMM_FILE: 'Flus. Amm. CSV',
			XML_AMM_FILE: 'Flus. Amm. XML',
			XLSX_AMM_FILE: 'Flus. Amm. XLSX',
			CSV_FILE: 'Flusso CSV',
			XML_FILE: 'Flusso XML',
			XLSX_FILE: 'Flusso XLSX',
			ORIGINAL_PDF_FILE: 'File originale Pdf',
			VECTOR_TXT: 'Vettoriamento e Txt',
			SUPPLIES: 'Forniture',
			REQUESTS: 'Richieste',
			READINGS: 'Letture',
			NEW_REQUEST: 'Nuova Richiesta',
			DOWNLOAD_PDR_REGISTRY: 'Scarica Anagrafica PdR'
		},
		SCHEDULE_RESEARCH: 'Ricerca schedulata',
		INSERT: 'Inserisci',
		DOWNLOAD: 'Scarica',
		DOWNLOAD_LIST: 'Scarica selezionati',
		UPLOAD: 'Carica',
		FILTER: 'Filtra',
		EXTRACT: 'Estrai',
		EXPORT_LIST: 'Esporta selezionati',
		EXPORT_LIST_TITLE:
			'Esporta in un file xlsx i dati presenti in griglia relativi ai record selezionati',
		EXPORT_LIST_TOT: 'Esporta risultati',
		EXPORT_LIST_TOT_TITLE:
			'Esporta in un file xlsx i dati presenti in griglia',
		DOWNLOAD_LIST_CSV_FILE: 'Scarica file (CSV)',
		DOWNLOAD_LIST_CSV_FILE_TITLE:
			'Esegue il download massivo dei flussi di esito in formato .csv',
		DOWNLOAD_LIST_XML_FILE: 'Scarica file (XML)',
		DOWNLOAD_LIST_XML_FILE_TITLE:
			'Esegue il download massivo dei flussi di esito in formato .xml',
		DOWNLOAD_LIST_XLSX_FILE: 'Scarica file (XLSX)',
		DOWNLOAD_LIST_XLSX_FILE_TITLE:
			'Esegue il download massivo dei flussi di esito in formato .xlsx',
		SEARCH: 'Ricerca',
		ELABORATE: 'Elabora',
		DELETE: 'Cancella',
		RESET: 'Reset',
		CLEAR: 'Clear',
		CLOSE: 'Chiudi',
		SAVE: 'Salva',
		PRINT: 'Stampa',
		CONFIRM: 'Conferma',
		SUBMIT: 'Salva',
		BACK: 'Indietro',
		NEXT: 'Avanti',
		HANDLE: 'Gestisci',
		ADD: 'Aggiungi',
		REFRESH: 'Aggiorna',
		CANCEL: 'Annulla',
		CHANGE: 'Modifica',
		DANGER: 'Attenzione!'
	},

	LAYOUT: {
		OBLIGATORY: '* campi obbligatori',
		ADDITIONAL_FILTERS: 'Mostra altri filtri'
	},
	VALIDATIONS: {
		REQUIRED: 'Campo richiesto',
		PATTERN: {
			GENERIC: 'Formato non valido',
			EMAIL: 'Email non idonea',
			CAP: 'CAP non idoneo',
			CF: 'CF non idoneo',
			COORDINATE: 'Coordinate non idonee',
			TIME: 'Orario non ideneo usare hh:mm',
			PHONE: 'Numero non idoneo',
			DATE: 'Data antecedente al rilascio',
			DATE_BEFORE_TODAY: 'Data immessa precedente alla data corrente',
			DATE_AFTER:
				'Errore! Immettere data antecedente alla data {{typeDate}}',
			DATE_BEFORE:
				'Errore! Immettere data successiva alla data {{typeDate}}',
			MICROCHIPS: 'Microchips superiore ai capi',
			DATE_AMBUSH: 'Licenza scaduta',
			AUTHORIZATION_END_DATE: 'Formato data non corretto',
			START_DATE_ERROR:
				'Errore! Immettere data antecedente alla data finale',
			END_DATE_ERROR:
				'Errore! Immettere data successiva alla data iniziale'
		},
		FILE_EXTENSION:
			'Errore! Il file non è del formato specificato. I formati ammessi sono: {{formats}}',
		EMPTY_FILE: 'Errore! Il file immesso è vuoto.',
		FILE_TOO_BIG:
			'Attenzione! Il file supera la dimensione massima di {{maxSize}} MB'
	},
	HEADER: {
		USER_MENU: {
			TITLE: 'Menu utente',
			ROLE: 'Ruolo',
			USER_DATA: 'Dati utente',
			EDIT_PASSWORD: 'Modifica password',
			LOGOUT: 'Logout'
		}
	},

	AUTH: {
		SUCCESSFUL_LOGIN_MESSAGE: "Hai effettuato l'accesso con successo!",
		FAILED_LOGIN_WRONG_CREDENTIALS: 'Le credenziali inserite sono errate.',
		FAILED_LOGIN_ERROR: 'Si è verificato un problema. Riprova di nuovo',
		LOGOUT: 'Sto effettuando la procedura di logout...'
	}
};
